import type { VisibilityModelId } from '../types/ids';

/** Kontrollierte Texte je empfohlenem Sichtbarkeitsmodell (Abschnitt 20). */
export interface VisibilityModelCopy {
  summary: string;
}

export const VISIBILITY_MODEL_COPY: Record<VisibilityModelId, VisibilityModelCopy> = {
  personal_expert: {
    summary:
      'Du trittst persönlich mit Gesicht und Stimme als Expertin oder Experte auf. Das passt gut, wenn dir regelmäßige Kommunikation und persönliche Sichtbarkeit leichtfallen.',
  },
  professional_personal_brand: {
    summary:
      'Du zeigst dich fachlich persönlich – über Sprache, Werte, Arbeitsweise und Entscheidungen – ohne dein Privatleben in den Mittelpunkt zu stellen.',
  },
  method_or_product_brand: {
    summary:
      'Deine Methode oder dein Produkt steht im Mittelpunkt. Persönliche Vertrauenssignale wie Stimme oder Beispiele ergänzen den Auftritt gezielt.',
  },
  faceless: {
    summary:
      'Ein weitgehend unpersönlicher Account mit Grafiken, Text, Animationen oder Bildschirmaufnahmen ist möglich, solange der Vertrauensbedarf des Angebots das zulässt.',
  },
};

/** Hinweistext, falls keine Regel eindeutig passt (ERR-007). */
export const VISIBILITY_MODEL_FALLBACK_NOTICE =
  'Für dein gewähltes Sichtbarkeitsmodell konnte keine eindeutige automatische Empfehlung ermittelt werden. Das gewählte Modell wird deshalb unverändert angezeigt.';

export const PERSONAL_VISIBILITY_NOTICE =
  'Persönlich sichtbar zu sein bedeutet nicht, das Privatleben zu veröffentlichen.';
